import gql from 'graphql-tag';

const guaranteePurchaseAuditsQuery = gql`
  query guaranteePurchaseAudits(
    $guaranteePurchaseId: Int!
    $startDate: String
    $endDate: String
    $size: Int
    $offset: Int
  ) {
    guaranteePurchaseAudits(
      guaranteePurchaseId: $guaranteePurchaseId
      startDate: $startDate
      endDate: $endDate
      size: $size
      offset: $offset
    ) {
      id
      whodunnit
      event
      versionAuthor
      itemType
      changeset
      timeStamp
    }
  }
`;

export default guaranteePurchaseAuditsQuery;
